import { render } from "./SmallLoader.vue?vue&type=template&id=62b908fb&scoped=true"
import script from "./SmallLoader.vue?vue&type=script&lang=js"
export * from "./SmallLoader.vue?vue&type=script&lang=js"

import "./SmallLoader.vue?vue&type=style&index=0&id=62b908fb&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b908fb"]])

export default __exports__